import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { OmniSearchRequest, OmniSearchRequestByCompany, OmniSearchRequestByProvider, OmniSearchRequestByTenantId } from '@fitness-force/models';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '@fitness-force/environments';
import { AppErrors, NotFoundError } from '@fitness-force/models';;

@Injectable({
  providedIn: 'root'
})
export class OmniSearchService {
  private http = inject(HttpClient);

  BASE_URL: string = environment.BASE_URL;

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };

  Search(request: OmniSearchRequest): Observable<any> {
    return this.http.post<any>(this.BASE_URL + CONST_URL_SEGEMENTS.SEARCH.POST_SEARCH, request, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  SearchByTenantId(tenantId: string, request: OmniSearchRequestByTenantId): Observable<any> {
    return this.http.post<any>(this.BASE_URL + CONST_URL_SEGEMENTS.SEARCH.POST_SEARCH_BY_TENANT_ID.replace('{tenant_id}', tenantId), request, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  searchByCompany(request: OmniSearchRequestByCompany): Observable<any> {
    return this.http.post<any>(this.BASE_URL + CONST_URL_SEGEMENTS.SEARCH.POST_SEARCH_BY_COMPANY, request, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  SearchByProvider(tenantId: number, provider: string, request: OmniSearchRequestByProvider): Observable<any> {
    return this.http.post<any>(this.BASE_URL + CONST_URL_SEGEMENTS.SEARCH.POST_SEARCH_BY_PROVIDER.replace('{tenant_id}', tenantId.toString()).replace('{provider_name}', provider), request, this.httpOptions)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
}
